import {
  AccountIcon,
  ActivityLogIcon,
  BlogIcon,
  ConnectIcon,
  CrownWhiteIcon,
  EngageIcon,
  ExploreIcon,
  FeedbackIcon,
  HomeIcon,
  LogoutIcon,
  ReferIcon,
  SettingsIcon,
  SuccessStoriesIcon,
  TermsIcon,
  WeddingStoriesIcon,
} from "assets/icons";

export const links = [
  {
    key: 1,
    label: "My profile",
    icon: AccountIcon,
    href: "/my-profile",
  },
  {
    key: 2,
    label: "Settings",
    icon: SettingsIcon,
    href: "/settings",
  },
  {
    key: 3,
    label: "Blogs",
    icon: BlogIcon,
    href: "/blog",
  },
  {
    key: 4,
    label: "Success stories",
    icon: SuccessStoriesIcon,
    href: "/success-stories",
  },
  {
    key: 5,
    label: "Wedding stores",
    icon: WeddingStoriesIcon,
    href: "/wedding-store",
  },
  {
    key: 6,
    label: "Activity log",
    icon: ActivityLogIcon,
    href: "/activity-log",
  },
  {
    key: 7,
    label: "Refer & Reward",
    icon: ReferIcon,
    href: "/settings",
    state: { activeTab: "5" },
  },
  {
    key: 8,
    label: "Feedback",
    icon: FeedbackIcon,
  },
  {
    key: 9,
    label: "Terms & Condition",
    icon: TermsIcon,
    href: "/terms-and-conditions",
  },
];

export const responsiveProfileData = [
  {
    key: 1,
    label: "Home",
    href: "/home",
    icon: HomeIcon,
  },
  {
    key: 2,
    label: "Explore",
    href: "/explore",
    icon: ExploreIcon,
  },
  {
    key: 3,
    label: "Engage",
    href: "/engage",
    icon: EngageIcon,
  },
  {
    key: 4,
    label: "Connect",
    href: "/connect",
    icon: ConnectIcon,
  },
  {
    key: 15,
    label: "Plans",
    href: "/plans",
    icon: CrownWhiteIcon,
  },
  {
    key: 5,
    label: "My profile",
    icon: AccountIcon,
    href: "/my-profile",
  },
  {
    key: 6,
    label: "Settings",
    icon: SettingsIcon,
    href: "/settings",
  },
  {
    key: 7,
    label: "Blogs",
    icon: BlogIcon,
    href: "/blog",
  },
  {
    key: 8,
    label: "Success stories",
    icon: SuccessStoriesIcon,
    href: "/success-stories",
  },
  {
    key: 9,
    label: "Wedding stores",
    icon: WeddingStoriesIcon,
    href: "/wedding-store",
  },
  {
    key: 10,
    label: "Activity log",
    icon: ActivityLogIcon,
    href: "/activity-log",
  },
  {
    key: 11,
    label: "Refer a friend",
    icon: ReferIcon,
    href: "/settings",
    state: { activeTab: "5" },
  },
  {
    key: 12,
    label: "Feedback",
    icon: FeedbackIcon,
    href: "#",
  },
  {
    key: 13,
    label: "Terms & Condition",
    icon: TermsIcon,
    href: "/terms-and-conditions",
  },
  {
    key: 14,
    label: "Log out",
    icon: LogoutIcon,
  },
];
